import { CommunicationProvider, useCommunication } from "@/lib/CommunicationWrapper";
import { NotesProvider } from "./contexts/NotesContext";
import { Notes } from "./components/Notes";
import { useEffect, useState, useRef } from "react";
import { WithTheme } from "@/lib/WithTheme";
import { FirstTimeOnboarding } from "@/src/components/FirstTimeOnboarding";
import { NOTES_ONBOARDING_STEPS } from "@/lib/page-onboarding";

const NotesPageContent = () => {
    const { getOptions, updateOptions } = useCommunication();
    const [showOnboarding, setShowOnboarding] = useState(false);
    const [portalElement, setPortalElement] = useState<HTMLDivElement | null>(null);
    const hasCheckedOnboarding = useRef(false);

    useEffect(() => {
        if (hasCheckedOnboarding.current) return;
        hasCheckedOnboarding.current = true;

        const options = getOptions();
        if (!options.notes_onboarding_viewed) {
            setShowOnboarding(true);
        }
    }, [getOptions]);

    const handleOnboardingComplete = () => {
        updateOptions({ notes_onboarding_viewed: true });
        setShowOnboarding(false);
    };

    const handleOnboardingSkip = () => {
        updateOptions({ notes_onboarding_viewed: true });
        setShowOnboarding(false);
    };

    return (
        <>
            <div className="fixed top-0 left-0 z-[100000000000000]" ref={setPortalElement} />
            <NotesProvider>
                <Notes />
                <FirstTimeOnboarding
                    isOpen={showOnboarding}
                    onComplete={handleOnboardingComplete}
                    onSkip={handleOnboardingSkip}
                    steps={NOTES_ONBOARDING_STEPS}
                    container={portalElement}
                />
            </NotesProvider>
        </>
    );
};

export const NotesPage = () => {
    return (
        <CommunicationProvider>
            <WithTheme />
            <NotesPageContent />
        </CommunicationProvider>
    )
}

export default NotesPage;